/* eslint-disable @typescript-eslint/no-explicit-any */

import styles from "./button.module.css";

export type TypeStyle = "small" | "cancel" | "secundary" | "full";
export type TypeVariant = "contain" | "outlined" | "textButton";

const Button = ({
  variant,
  type,
  onClick,
  onMouseDown,
  children,
  title,
  disabled,
  style,
  className,
  typeStyle,
}: {
  variant: TypeVariant;
  type?: "reset" | "submit" | "reset" | "button" | undefined;
  onClick?: (e?: unknown | any) => void;
  onMouseDown?: (e?: unknown | any) => void;
  children?: React.ReactNode;
  title?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
  className?: string;
  typeStyle?: TypeStyle | TypeStyle[];
}) => {
  const processedTypeStyle = Array.isArray(typeStyle)
    ? typeStyle.map((item) => styles[item]).join(" ")
    : typeStyle
      ? styles[typeStyle]
      : "";

  return (
    <button
      type={type}
      className={`${styles[variant]} ${processedTypeStyle} ${className || ""}`}
      onClick={onClick}
      onMouseDown={onMouseDown}
      title={title}
      disabled={disabled}
      style={style}
    >
      {children}
    </button>
  );
};

export default Button;
